import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SimpleHeaderComponent } from './simple-header/simple-header.component';
import { SimpleFooterComponent } from './simple-footer/simple-footer.component';
import { BodyComponent } from './body/body.component';
import { EmbedComponent } from './embed/embed.component';
import { HeadlineComponent } from './headline/headline.component';
import { ImageComponent } from './image/image.component';
import { OrderedListComponent } from './ordered-list/ordered-list.component';
import { UnorderedListComponent } from './unordered-list/unordered-list.component';
import { PreambleComponent } from './preamble/preamble.component';
import { QuoteComponent } from './quote/quote.component';
import { FactboxComponent } from './factbox/factbox.component';
import { VideoComponent } from './video/video.component';
import { SimpleVideoPlayerComponent } from './simple-video-player/simple-video-player.component';
import { AngularSharedUtilNmoModule } from '@candyland/angular/shared/util-nmo';
import { IframeComponent } from './iframe/iframe.component';
import { RouterModule } from '@angular/router';
import { JobTeaserComponent } from './job-teaser/job-teaser.component';
import { LoadingIndicatorComponent } from './loading-indicator/default/loading-indicator.component';
import { LinkChoiceComponent } from './link-choice/link-choice.component';
import { ExternalContentComponent } from './external-content/external-content.component';
import { CustomAdsComponent } from './custom-ads/custom-ads.component';
import { SectionTitleComponent } from './section-title/section-title.component';
import { MoreCategoriesComponent } from './more-categories/more-categories.component';
import { UpSellingAdsComponent } from './up-selling-ads/up-selling-ads.component';
import { DynamicModule, DynamicIoModule } from 'ng-dynamic-component';
import { LoadingOverlayComponent } from './loading-indicator/overlay/loading-overlay.component';
import { HomeTopArticleTeaserComponent } from './home-top-article-teaser/home-top-article-teaser.component';
import { GiphyComponent } from './giphy/giphy.component';
import { ContentPartComponent } from './content-part/content-part.component';
import { DossierIconComponent } from './dossier-icon/dossier-icon.component';
import { KavedoComponent } from './kavedo/kavedo.component';
import { ContentSliderComponent, ContentSliderItemComponent } from './content-slider';
import { ArticleTeaserV3Component } from './article-teaser-v3/article-teaser-v3.component';
import { MediumTeaserComponent } from './article-teaser-v3/medium-teaser/medium-teaser.component';
import { PictureComponent } from './image/picture/picture.component';
import { MobileTeaserComponent } from './article-teaser-v3/mobile-teaser/mobile-teaser.component';
import { SearchTeaserComponent } from './article-teaser-v3/search-teaser/search-teaser.component';
import { SeparatorComponent } from './separator/separator.component';
import { PodcastComponent } from './podcast/podcast.component';
import { MaterialDialogComponent } from './material-dialog/material-dialog.component';
import { SharedAPIErrorComponent } from './shared-api-error/shared-api-error.component';
import { UnsupportedBrowserNotificationComponent } from './unsupported-browser-notification/unsupported-browser-notification.component';
import { ApaGraphicsComponent } from './apa-graphics/apa-graphics.component';
import { MostReadComponent } from './most-read/most-read.component';
import { EditorialsModuleComponent } from './editorials-module/editorials-module.component';
import { TeaserLinkComponent } from './teaser-link/teaser-link.component';
import { GamesModuleComponent } from './games-module/games-module.component';
import { RecommendedByEditorsComponent } from './recommended-by-editors/recommended-by-editors.component';
import { EditorialTeaserComponent } from './editorial-teaser/editorial-teaser.component';
import { SharePopupComponent } from './share-popup/share-popup.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatIconModule } from '@angular/material/icon';
import { JotformFormComponent } from './jotform-form/jotform-form.component';
import { WeatherLocationForecastComponent } from './weather-location-forecast/weather-location-forecast.component';
import { WeatherMapForecastComponent } from './weather-map-forecast/weather-map-forecast.component';
import { WeatherMapItemComponent } from './weather-map-forecast/weather-map-item/weather-map-item.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
// eslint-disable-next-line
import { AngularTtComWwwFeatureDfpComponentModule } from '@candyland/angular/tt-com-www/feature-dfp-component';
import { MatExpansionModule } from '@angular/material/expansion';
import { DpaSportsliveComponent } from './dpa-sportslive/dpa-sportslive.component';
import { DpaElectionsliveComponent } from './dpa-electionslive/dpa-electionslive.component';
import { DpaEmbedsComponent } from './dpa-embeds/dpa-embeds.component';
import { RecommendedArticlesComponent } from './recommended-articles/recommended-articles.component';
import { LiveblogEmbedWrapperComponent } from './liveblog-embed-wrapper/liveblog-embed-wrapper.component';
import { StoryViewComponent } from './story-view/story-view.component';
import {
  AuthorImageSourceSetComponent,
  InfomakerImageSourceSetComponent,
} from '@candyland/angular/shared/tt-com-processing/image/infomaker/feature';
import { ArticleTeaserRedesignComponent } from './article-teaser-redesign/article-teaser-redesign.component';
import { VevComponent } from './vev/vev.component';
import { TtShortsComponent } from './tt-shorts/tt-shorts.component';
import { PinpollComponent } from './pinpoll-embed/pinpoll.component';
import { SinnmacherComponent } from './sinnmacher/sinnmacher.component';

@NgModule({
  declarations: [
    JobTeaserComponent,
    SimpleHeaderComponent,
    SimpleFooterComponent,
    BodyComponent,
    EmbedComponent,
    HeadlineComponent,
    ImageComponent,
    OrderedListComponent,
    UnorderedListComponent,
    PreambleComponent,
    QuoteComponent,
    FactboxComponent,
    VideoComponent,
    SimpleVideoPlayerComponent,
    IframeComponent,
    LoadingIndicatorComponent,
    LinkChoiceComponent,
    ExternalContentComponent,
    CustomAdsComponent,
    SectionTitleComponent,
    MoreCategoriesComponent,
    MostReadComponent,
    RecommendedByEditorsComponent,
    GamesModuleComponent,
    EditorialsModuleComponent,
    UpSellingAdsComponent,
    LoadingOverlayComponent,
    HomeTopArticleTeaserComponent,
    GiphyComponent,
    KavedoComponent,
    ContentPartComponent,
    DossierIconComponent,
    ContentSliderComponent,
    ContentSliderItemComponent,
    ArticleTeaserV3Component,
    MediumTeaserComponent,
    PictureComponent,
    MobileTeaserComponent,
    SearchTeaserComponent,
    SeparatorComponent,
    PodcastComponent,
    MaterialDialogComponent,
    SharedAPIErrorComponent,
    UnsupportedBrowserNotificationComponent,
    ApaGraphicsComponent,
    TeaserLinkComponent,
    EditorialTeaserComponent,
    SharePopupComponent,
    JotformFormComponent,
    WeatherLocationForecastComponent,
    WeatherMapForecastComponent,
    WeatherMapItemComponent,
    DpaSportsliveComponent,
    DpaElectionsliveComponent,
    DpaEmbedsComponent,
    RecommendedArticlesComponent,
    StoryViewComponent,
    ArticleTeaserRedesignComponent,
    PinpollComponent,
    SinnmacherComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    DynamicModule,
    DynamicIoModule,
    AngularSharedUtilNmoModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatDialogModule,
    MatButtonModule,
    ClipboardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCardModule,
    AngularTtComWwwFeatureDfpComponentModule,
    MatExpansionModule,
    NgOptimizedImage,
    LiveblogEmbedWrapperComponent,
    AuthorImageSourceSetComponent,
    InfomakerImageSourceSetComponent,
    VevComponent,
    TtShortsComponent,
  ],
  exports: [
    ArticleTeaserV3Component,
    JobTeaserComponent,
    SimpleHeaderComponent,
    SimpleFooterComponent,
    EmbedComponent,
    HeadlineComponent,
    ImageComponent,
    OrderedListComponent,
    UnorderedListComponent,
    PreambleComponent,
    QuoteComponent,
    FactboxComponent,
    VideoComponent,
    SimpleVideoPlayerComponent,
    IframeComponent,
    LoadingIndicatorComponent,
    LinkChoiceComponent,
    ExternalContentComponent,
    CustomAdsComponent,
    SectionTitleComponent,
    MoreCategoriesComponent,
    MostReadComponent,
    GamesModuleComponent,
    RecommendedByEditorsComponent,
    EditorialsModuleComponent,
    UpSellingAdsComponent,
    LoadingOverlayComponent,
    HomeTopArticleTeaserComponent,
    GiphyComponent,
    KavedoComponent,
    ContentPartComponent,
    ContentSliderComponent,
    ContentSliderItemComponent,
    PictureComponent,
    SeparatorComponent,
    PodcastComponent,
    SharedAPIErrorComponent,
    UnsupportedBrowserNotificationComponent,
    ApaGraphicsComponent,
    TeaserLinkComponent,
    EditorialTeaserComponent,
    SharePopupComponent,
    JotformFormComponent,
    WeatherLocationForecastComponent,
    WeatherMapForecastComponent,
    DpaSportsliveComponent,
    DpaElectionsliveComponent,
    DpaEmbedsComponent,
    RecommendedArticlesComponent,
    LiveblogEmbedWrapperComponent,
    StoryViewComponent,
    DossierIconComponent,
    ArticleTeaserRedesignComponent,
    VevComponent,
    TtShortsComponent,
    PinpollComponent,
    SinnmacherComponent,
  ],
})
export class AngularSharedUiNmoModule {}
